import { render, staticRenderFns } from "./LoteDesinfetante.vue?vue&type=template&id=424357d9&"
import script from "./LoteDesinfetante.vue?vue&type=script&lang=js&"
export * from "./LoteDesinfetante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports